const goods = {
  product: 1,
  food: 2,
};

export default goods;
